export const createBillableUnit = `
    mutation createBillableUnit($input: CreateBillableUnitInput!) {
        createBillableUnit(input:$input) {
            id
            name
            description
            meterId
            meteredUnitsPerBillableUnit
            status
            createdByUsername
            created
            updated
    }
}`;

export const updateBillableUnit = `
    mutation updateBillableUnit($input: UpdateBillableUnitInput!) {
        updateBillableUnit(input:$input){
            id
            name
            description
            meterId
            meteredUnitsPerBillableUnit
            status
            createdByUsername
            created
            updated
        }
}`;

export const deleteBillableUnit = `
    mutation deleteBillableUnit($input: DeleteBillableUnitInput!) {
        deleteBillableUnit(input:$input)
}`;
